const buildUrl = function (template, params) {
	return template.replace(/{([^{}]+)}/g, (match, key) =>
		(Object.prototype.hasOwnProperty.call(params, key) ? encodeURIComponent(params[key]) : 'none'));
};

const getInvalidFormIdError = function () {
	return new Error('Invalid form ID');
};

/**
 * nf_get_forms_data is localized by PHP and carries the REST nonce. If its handle is
 * dequeued the global is simply absent, and dereferencing it inside a Promise executor
 * rejects with a ReferenceError that is easy to mistake for a form that never loads.
 * Report it instead of letting the caller hang.
 */
const isNonceAvailable = function () {
	return !!(window.nf_get_forms_data && window.nf_get_forms_data.NONCE);
};

const getMissingNonceError = function () {
	return new Error('nf_get_forms_data is not defined - the REST nonce was never localized, so the form cannot be requested');
};

// TODO Remove the additionalParams argument after AB#245834 is in prod
// as it is not involved in the backend logic of the /get_form endpoint
export const getForm = function (formId, nfFormsCounter, additionalParams = {}) {
	if (!isNonceAvailable()) {
		return Promise.reject(getMissingNonceError());
	}
	if ($('.ENABLE_CACHE_LAZY_FORMS').length > 0) {
		return new Promise((resolve, reject) => {
			const filteredFormId = parseInt(formId, 10);
			if (isNaN(filteredFormId)) {
				reject(getInvalidFormIdError());
			}
			const urlPathTemplate = '/wp-json/nf_tp/get_form/{form_id}/{async_form}/{nf_forms_counter}';
			const formData = {
				form_id: filteredFormId,
				async_form: 1,
				nf_forms_counter: nfFormsCounter,
			};
			const url = buildUrl(urlPathTemplate, formData);
			const urlParams = { _wpnonce: nf_get_forms_data.NONCE };
			$.get(url, urlParams, response => resolve(response));
		});
	}
	// Remove after AB#245834 in prod
	return new Promise((resolve) => {
		const formData = Object.assign({
			form_id: formId,
			async_form: true,
			nf_forms_counter: nfFormsCounter,
		}, additionalParams);
		formData._wpnonce = nf_get_forms_data.NONCE;
		$.post('/wp-json/nf_tp/get_form', formData, response => resolve(response));
	});
};

export const getFormKey = function (formId) {
	if ($('.ENABLE_CACHE_LAZY_FORMS').length > 0) {
		const filteredFormId = parseInt(formId, 10);
		if (isNaN(filteredFormId)) {
			throw getInvalidFormIdError();
		}
		return btoa(filteredFormId);
	}
	// Remove after AB#2245834 in prod
	return btoa(formId);
};



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/forms/contact-forms-lazy-load/utils.js